import VersionsTable from './VersionsTable';

export default VersionsTable;
